import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { AlertCircle, ChevronDown, ChevronUp } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ErrorReporter } from '@/app/tracking';

/**
 * DefaultError Component
 *
 * @param {object} props
 * @param {Error} props.error - The error object.
 * @param {function} props.refetch - Function to retry fetching data.
 */
function DefaultError({ error, refetch }) {
  const [isOpen, setIsOpen] = useState(false);

  // Safely access error properties with fallbacks
  let errorCode = error?.errorCode || error?.code || 'N/A';
  let message = error?.message || 'An unknown error occurred';
  let stack = error?.stack;
  let msg = "DefaultError " + window.location.pathname + ": " + message;

  ErrorReporter.error({ msg, stack, errorCode });

  return (
    <div className="flex flex-col items-center gap-4 p-4">
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Error{errorCode !== 'N/A' && ` Code: ${errorCode}`}
          </AlertTitle>        
        <AlertDescription className="flex flex-col gap-2">
          <p>{message}</p>
          {!stack && <p className="text-xs text-muted-foreground">{window.location.pathname}</p>}

          {stack && (
            <Collapsible
              open={isOpen}
              onOpenChange={setIsOpen}
              className="w-full"
            >
              <div className="flex items-center mt-1">
                <span className="text-sm font-medium">Details</span>
                <CollapsibleTrigger className="p-2 rounded-md hover:bg-gray-100">
                  {isOpen ? (
                    <ChevronUp className="h-4 w-4" />
                  ) : (
                    <ChevronDown className="h-4 w-4" />
                  )}
                </CollapsibleTrigger>
              </div>
              <CollapsibleContent>
               <p className="text-xs text-muted-foreground">{window.location.pathname}</p>
                <pre className="mt-2 rounded-md bg-slate-950 p-4 text-sm text-slate-50 overflow-auto max-h-[300px]">
                  {stack}
                </pre>
              </CollapsibleContent>
            </Collapsible>
          )}
        </AlertDescription>
      </Alert>

      <Button onClick={refetch} variant="default">
        Retry
      </Button>
    </div>
  );
}

export default DefaultError;